import axios from 'axios';
import { API_URL } from '../config';

export const getJustificationRequestsCompanyList = async (
  token: string, 
  fromDate: string, 
  page: number, 
  pageSize: number = 10, 
  status: string, 
  selectedUnit: number | null = null, 
  selectedEmployees: number[] = [], 
  toDate: string, 
  signal: AbortSignal | null = null,
  permission: string | null,
) => {
  const config: any = {};
  if(signal !== null)
    config.signal = signal;

  if (permission) 
    config.permission = permission

  const response = await axios.get(`${API_URL}/presenze/company/justification-requests/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
      params: {
        from_date: fromDate,
        page: page,
        page_size: pageSize,
        status: status,
        ou: selectedUnit,
        employees: selectedEmployees.join(','),
        to_date: toDate
      },
      ...config,
    });
    return response.data;
};

export const getJustificationRequestCompany = async (token: string, id: string) => {
  const response = await axios.get(`${API_URL}/presenze/company/justification-requests/${id}/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
  return response.data;
};
  
export const updateJustificationRequestStatus = async (token: string, id: string | number, newStatus?: string, reviewedOn?: Date, startTime?: string, endTime?: string, note?: string, ouId?: number) => {
  const response = await axios.patch(`${API_URL}/presenze/company/justification-requests/${id}/`,
    {
      status: newStatus,
      reviewed_on: reviewedOn,
      datetime_from: startTime,
      datetime_to: endTime,
      note: note,
      ou: ouId,
    }, {
      headers: {
        'Authorization': token,
      },
    }
  );
  return response.data;  
}; 


export const deleteJustificationRequest= async (token: string, id: number) => {
  const response = await axios.delete(`${API_URL}/presenze/company/justification-requests/${id}/`,
   {
      headers: {
        'Authorization': `${token}`,
      },
    });
  return response.data;
};

export const createEmployeeJustificationRequest= async (token: string, employeeId: number, data: any) => {
  const response = await axios.post(`${API_URL}/presenze/employee/${employeeId}/justification-requests/`,
    data,
   {
      headers: {
        'Authorization': `${token}`,
      },
    });
  return response.data;
};


export const getJustificationRequestsSummary = async (
  token: string,
  fromDate: string,
  toDate: string,
  status: string,
  selectedUnit: number | null = null,
  selectedEmployees: number[] = [],
  page: number = 1,
  pageSize: number = 25,
  signal: AbortSignal | null = null,
  permission: string | null = null
) => {
  const config: any = {};
  if (signal !== null) config.signal = signal;
  if (permission) config.permission = permission;

  const response = await axios.get(
    `${API_URL}/presenze/company/justification-requests/summary/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
      params: {
        from_date: fromDate,
        to_date: toDate,
        status,
        ou: selectedUnit,
        employees: selectedEmployees.join(','),
        page,
        page_size: pageSize,
      },
      ...config,
    }
  );

  return response.data;
};


export const bulkUpdateJustificationRequestsStatus = async (
  token: string,
  newStatus: 'approved' | 'rejected',
  fromDate: string,
  toDate: string,
  selectedUnit: number | null = null,
  selectedEmployees: number[] = [],
  filterStatus: string = 'null',
  signal: AbortSignal | null = null,
  permission: string | null = null
) => {
  const config: any = {};
  if (signal)     config.signal = signal;
  if (permission) config.permission = permission;

  const res = await axios.post(
    `${API_URL}/presenze/company/justification-requests/${newStatus}-all/`,
    null,
    {
      headers: { Authorization: `${token}` },
      params: {
        from_date: fromDate,
        to_date: toDate,
        ou: selectedUnit,
        employees: selectedEmployees.join(','),
        status: filterStatus,
      },
      ...config,
    }
  );

  return res.data;
};
